
  import { computed, defineComponent } from 'vue';

  interface ChevronIconProps {
    width: number;
    height: number;
    direction: 'up' | 'right' | 'down' | 'left';
  }

  export default defineComponent<ChevronIconProps>({
    props: {
      width: {
        type: Number,
        required: false,
        default: 24,
      },
      height: {
        type: Number,
        required: false,
        default: 24,
      },
      direction: {
        type: String,
        required: false,
        default: 'right',
      },
    },
    setup(props) {
      const rotations = {
        up: 270,
        right: 0,
        down: 90,
        left: 180,
      };

      const rotateProperty = computed(() => {
        const rotate = rotations[props.direction] || 0;
        return `rotate(${rotate} ${props.width / 2} ${props.height / 2})`;
      });

      return {
        rotateProperty,
      };
    },
  });
